import React from "react";
import Reveal from "../ui/Reveal";
import SectionHeading from "../ui/SectionHeading";
import Github from "./Github";
import { SKILLS } from "../../data/portfolio";

function Skills() {
  return (
    <section id="skills" className="section">
      <div className="container-page flex flex-col gap-14">
        <SectionHeading
          kicker="Skills"
          title="Tools I reach for"
          subtitle="A pragmatic toolkit built around the MERN stack, extended into data and hardware."
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SKILLS.map((cat, i) => (
            <Reveal key={cat.group} delay={i * 70} className="card-surface p-6">
              <h3 className="font-display text-lg font-semibold text-ink">{cat.group}</h3>
              <div className="mt-4 flex flex-wrap gap-2">
                {cat.items.map((item) => (
                  <span
                    key={item}
                    className="chip transition-colors hover:border-accent/50 hover:text-ink"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </Reveal>
          ))}
        </div>

        <Github />
      </div>
    </section>
  );
}

export default Skills;
